import React, { useState } from "react";
import { ParallaxProvider, ParallaxBanner } from "react-scroll-parallax";

const BannerParallax = props => {
  const [background] = useState(props.background);

  return (
    <ParallaxProvider>
      <ParallaxBanner
        className="parallax_banner"
        layers={[
          {
            image: background,
            amount: 0.5
          }
        ]}
        style={{
          height: '60vh',
        }}
      ></ParallaxBanner>
    </ParallaxProvider>
  );
};

export default BannerParallax;
